import React from "react";
import trackStep1 from "./images/track-step-1.svg?url";
import trackStep2 from "./images/track-step-2.svg?url";
import trackStep3 from "./images/track-step-3.svg?url";
import trackStep4 from "./images/track-step-4.svg?url";
import trackStep5 from "./images/track-step-5.svg?url";
import trackStep6 from "./images/track-step-6.svg?url";
import { BFID_URL, rootUrl } from "@bundles/consts";
import { formatNumberToUSD } from "@features/utils/functions";

export const getTrack1Cards = (
  slug?: string,
  timelockMinValue?: number,
  isUk?: boolean,
  handleClickOnStepOneLink?: () => void
) => [
  {
    step: 1,
    title: "Tier 1 approved",
    imageSrc: trackStep1,
    description: (
      <>
        <p>
          In order to qualify to get the Bitcoin Wealth Builder Program
          {isUk ? "" : " for FREE"}, you need a minimum of a Tier 1 Investor
          Account.
          {isUk ? (
            ""
          ) : (
            <>
              &nbsp;Full details of what is included in a Tier 1 Account can be
              found{" "}
              <a
                className="underline font-semibold"
                onClick={handleClickOnStepOneLink}
              >
                here
              </a>
              .
            </>
          )}
        </p>
      </>
    ),
    buttonText: "Upgrade To Tier 1 Now",
    buttonLink: BFID_URL,
  },
  {
    step: 2,
    title: "Stake ETH",
    imageSrc: trackStep2,
    description: (
      <>
        <p>
          In order to qualify to get the Bitcoin Wealth Builder Program&nbsp;
          {isUk ? "" : "for FREE"}, you need to stake a minimum of&nbsp;
          {formatNumberToUSD(timelockMinValue ?? 0)} worth of ETH with a minimum
          of a 1 year time-lock on our platform.
        </p>
      </>
    ),
    buttonText: "Buy, Deposit or Stake ETH Now",
    buttonLink: `${rootUrl}/profile/${slug}/funds/stakingEth`,
  },
  {
    step: 3,
    title: "Program activated",
    imageSrc: trackStep3,
    description: (
      <>
        <p>
          We need your permission to share your name, email, and country with
          the Bitcoin Wealth Builder Program partner. This will allow them to
          send your login details to the email address you used for your Bnk To
          The Future account.
        </p>
      </>
    ),
    buttonDisabled: isUk,
    buttonText: isUk ? "Coming in 2026" : "Share Email & Grant Access",
  },
];

export const getTrack2Cards = (slug?: string, isUk?: boolean) => [
  {
    step: 4,
    title: "Tax Technology",
    imageSrc: trackStep4,
    description: (
      <>
        <p className="mb-[8px] font-semibold">
          Claim Your Coupon Code & Setup your Tax Technology
        </p>
        <p>
          We’ve partnered with Recap, a privacy-centric crypto tax platform, to
          help you organize your transaction history for tax reporting. Use the
          coupon code in your account to get a discount and integrate Recap with
          your Bnk To The Future account.&nbsp;
          <a
            href="https://home.bnktothefuture.com/blog/connecting-your-bf-account-to-recap/"
            target="_blank"
            className="underline font-semibold"
          >
            Read more
          </a>
        </p>

        <p className="mt-[24px] text-grey-lightest text-xs">
          Disclaimer: Neither Bnk To The Future nor Recap provide tax advice.
          The tools and services offered by Recap are designed to assist with
          tax reporting only. For personalized tax advice, please consult a
          qualified tax professional.
        </p>
      </>
    ),
    buttonText: "Set Up Now",
    buttonLink: `${rootUrl}/profile/${slug}/account?scrollTo=api-management-section`,
  },
  {
    step: 5,
    title: "Complete Program",
    imageSrc: trackStep5,
    description: (
      <>
        <p className="mb-[8px] font-semibold">
          Complete Bitcoin Wealth Builder Program & High Net Worth Bitcoin
          Investor Challenge
        </p>
        <p>
          Once you have completed the Bitcoin Wealth Builder Program, accepted
          the High Net Worth Bitcoin Investor Challenge, and committed to owning
          more Bitcoin every month, confirm by clicking the button below, which
          will unlock the final step in track 2.
        </p>
      </>
    ),
    buttonText: "Accept Challenge",
  },
  {
    step: 6,
    title: "Inheritance Technology",
    imageSrc: trackStep6,
    description: (
      <>
        <p className="mb-[8px] font-semibold">
          Setup your inheritance technology
        </p>
        <p>
          {isUk
            ? "Our portfolio builder service offers an offshore asset retirement plan structure to hold all your investments. Join the waiting list clicking the button below."
            : "Our portfolio builder service offers an efficient offshore asset protection retirement plan structure to hold all your investments. Join the waiting list"}
        </p>
      </>
    ),
    buttonText: "Join Waiting List",
  },
];
